import type { InferOutput } from 'valibot'
import { SolrParamsKey } from '#shared/solr'
import { array, intersect, nullish, object, string } from 'valibot'
import { baseBodySchema } from '~/utils/solr/body'
import { facetCountsSchema } from '~/utils/solr/facet'
import { headersSchema } from '~/utils/solr/headers'
import { templateSchema } from '~/utils/solr/template'

export const solrTemplatesResponseSchema = object({
  responseHeader: headersSchema,
  response: intersect([
    baseBodySchema,
    object({
      docs: array(templateSchema),
    }),
  ]),
  facet_counts: nullish(facetCountsSchema),
})

export type SolrTemplatesResponseSchema = InferOutput<typeof solrTemplatesResponseSchema>

export const templatesSchema = object({
  filter: nullish(string()),
  sort: nullish(string()),
  // Optional: when provided, the API will filter templates by these legal areas.
  legal_areas: nullish(array(string())),
})

export type Templates = InferOutput<typeof templatesSchema>

export const templateParamsSchema = object({
  [SolrParamsKey.Templates]: nullish(templatesSchema),
  [SolrParamsKey.Template]: nullish(string()),
})

export type TemplateParams = InferOutput<typeof templateParamsSchema>

export function useTemplateQuery(params: MaybeRef<TemplateParams>) {
  const options = useSolrQueryOptions({
    endpoint: 'templates',
    params,
    schema: solrTemplatesResponseSchema,
    enabled: p => Object.values(p ?? {}).some(value => value !== undefined && value !== null),
  })

  return useQuery(options)
}
